import { apiClient } from "../http/httpClient";


export function NewsletterApi(contentType = "application/json")
{
    const http = apiClient(contentType);

    return {
        
       /**
        * POST /api/newsletters
        * @desc    Create a new newsletter subscription : Pas besoin d'authenfication
        * @access  Public
        * @param   {string} email - Email address to subscribe (required, must be valid email)
        * @returns {Object} Success status with newsletter subscription data
        */
        insert : (data) => http.post("/api/newsletters", data), 

        

      };
}

